import { PaymentInterval } from "../simulator/simulator";
import { getMaxTax, getMinTax, getTcBndes } from "./bndes";
const DEFAULT_COMMISSION_RATE = 0.05;
const MAX_TAX_BNDES = 3.79;
const MAX_ALLOWED_COMMISSION = 50000;

export interface ICommissionCalculateParams {
    amount: number,
    tenure: number,
    paymentInterval: PaymentInterval,
    discount?: number,
    rate?: number,
}

export const calculateCommission = (request: ICommissionCalculateParams) => {
    let annualModifier = request.paymentInterval == PaymentInterval.Weekly ? 52 : 12;
    
    var commission = Math.max(0,
        request.amount * (Math.pow(1 + (request.rate || (request.rate === 0 ? 0 : DEFAULT_COMMISSION_RATE)), request.tenure / annualModifier) - 1) - (request.discount || 0)
    );

    return Math.min(commission, MAX_ALLOWED_COMMISSION)
}

export const getBndesCommissionRate = (term: number, tax: number): number => {
    if (tax > getMaxTax() || tax > MAX_TAX_BNDES) {
        throw "Unsupported on Bndes";
    }
    var bndesTcRate = getTcBndes(term, normalizeTax(tax));
    if (bndesTcRate < 0) {
        throw "Unsupported on Bndes";
    } else {
        return Math.min(bndesTcRate, DEFAULT_COMMISSION_RATE);
    }
}

export const getDefaultCommissionRate = (): number => {
    return DEFAULT_COMMISSION_RATE;
}

function normalizeTax(tax: number): number {
    tax = ((Math.trunc(tax * 10) * 10) + 9) / 100;
    tax = Math.max(tax, getMinTax());
    tax = Math.min(tax, getMaxTax());
    return tax;
}